<template>
    <div class="not-found">
        <Content v-if="content">
            <div class="box" v-html="content"></div>
        </Content>
    </div>
</template>

<script>
import Content from '@/components/ui/Content.vue';

export default {
    name: 'NotFound',
    data() {
        return {
            content: '',
        }
    },
    components: {
        Content,
    },
    mounted() {
        this.$ajax.get('/options').then(res => {
            this.content = res.data.content_404;
        });
    },
}
</script>


<style lang="scss">
    .not-found {
        min-height: 80vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0  0 20rem;

        .ui-enter .box {
            text-align: center;
            max-width: 50rem;
            color: var(--black);

            // p {
            //     margin: 1rem 0 2rem 0;
            //     font-size: var(--base-size);
            // }

            // a {
            //     text-decoration: underline;
            //     &:hover {
            //         text-decoration: none;
            //     }
            // }
        }
    }
    @media only screen and (max-width: 767px) {
        .not-found {
            .ui-enter .box {
                max-width: 90vw;
            }
        }
    }
</style>
